module.exports = __webpack_public_path__ + "static/img/2.2ecce13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww/2.png
// module id = zw5Z
// module chunks = 0